import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { NAVERMAP_POLYLINE_STYLES } from "@/domain/entities/lineInfo";
import { NaveMapPolyLineStyle } from "@/types";
import { computed } from "vue";


const __default__ = {
  name: "LineTurnPathLegendLineStyle",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineIndex: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    default: "",
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "5d31c8b2-color": (__props.color)
}))

const props = __props;

const lineStyle = computed(
  () =>
    NAVERMAP_POLYLINE_STYLES[
      props.lineIndex % NAVERMAP_POLYLINE_STYLES.length
    ] ?? NaveMapPolyLineStyle.SOLID
);

const __returned__ = { props, lineStyle, get NaveMapPolyLineStyle() { return NaveMapPolyLineStyle } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})